import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { ExternalMark, externalLinkProps } from "@softmax/web-ux/shell";
import { ChannelAbout } from "./channel-about";
import { siteDomain } from "./coworld-values";

export function CoworldAboutLine({
  site,
  hideSiteOnNarrow = false,
  blurb,
  more,
}: {
  readonly site: string | undefined;
  readonly hideSiteOnNarrow?: boolean;
  readonly blurb: string;
  readonly more: string | null;
}) {
  return (
    <div {...stylex.props(styles.aboutLine)}>
      <ChannelAbout blurb={blurb} more={more} />
      {site === undefined ? null : (
        <a
          href={site}
          {...externalLinkProps}
          {...stylex.props(
            styles.siteLink,
            styles.aboutLink,
            hideSiteOnNarrow && styles.wideSite,
          )}
        >
          {siteDomain(site)}
          <ExternalMark />
        </a>
      )}
    </div>
  );
}

const wide = "@media (min-width: 640px)";

const styles = stylex.create({
  aboutLine: {
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
    gap: spacing.space4,
  },
  siteLink: {
    alignSelf: "flex-start",
    borderRadius: 3,
    fontSize: fontSizes.small,
    lineHeight: "19px",
    color: colors.secondary,
    textDecoration: { default: "none", ":hover": "underline" },
    textDecorationColor: colors.borderStrong,
    textUnderlineOffset: 3,
    ":focus-visible": {
      outlineWidth: 2,
      outlineStyle: "solid",
      outlineColor: colors.foreground,
      outlineOffset: 2,
    },
  },
  aboutLink: {
    whiteSpace: "nowrap",
    lineHeight: "18px",
    fontWeight: 500,
    color: colors.foreground,
  },
  wideSite: { display: { default: "none", [wide]: "inline" } },
});
